<script module lang="ts">
  import type { Snippet } from "svelte";
  import type { CollectionCardGridStoryblok } from '~/component-types-sb';

  export interface CollectionCardGridProps {
    blok: CollectionCardGridStoryblok;
    children?: Snippet;
  }
</script>

<script lang="ts">
  import { storyblokEditable } from "@storyblok/svelte";
  import { CollectionGrid } from "../../../components";

  const { blok }: CollectionCardGridProps = $props();
</script>
<CollectionGrid title={blok.headline} use={[[storyblokEditable, blok]]} collections={blok?.collections ?? []} />
